
const CareerInternshipPrepData = [
    {
        id: 1,
        heading: "I Landed My First Internship Abroad",
        text: "I used Holistic Learning’s resume template and LinkedIn checklist to apply for internships. I got a remote role with a startup in Toronto—and I’m still working with them today.",
        name: "Ahmed, Saudi Arabia | Computer Science, University of Toronto"
    },
    {
        id: 2,
        heading: "The CPT/OPT Guide Was a Lifesaver",
        text: "I didn’t understand how CPT and OPT worked until I read the Career Prep Kit. It explained everything clearly and helped me plan my timeline for job applications.",
        name: "Fatima, UAE | Business Analytics, Boston University"
    },
    {
        id: 3,
        heading: "My Resume Finally Got Noticed",
        text: "I’d been applying for jobs with no response. After using the resume template from the kit, I got three interview calls in one week. It made a huge difference.",
        name: "Khalid, Oman | Mechanical Engineering, University of Leeds"
    },
    {
        id: 4,
        heading: "LinkedIn Optimization = Recruiter Messages",
        text: "I followed the LinkedIn checklist step-by-step. Within two weeks, I started getting messages from recruiters and alumni in my field. It really works.",
        name: "Layla, Qatar | Marketing, University of Melbourne"
    },
    {
        id: 5,
        heading: "It Gave Me a Career Roadmap",
        text: "The Career Prep Kit helped me map out my goals—from internships to full-time roles. I now have a clear plan and timeline for every semester.",
        name: "Hassan, Bahrain | Data Science, University of British Columbia"
    },
    
];

export default CareerInternshipPrepData;